<template>
  <div>
    <v-icon
      v-if="produto.icon_mercado"
      small
      title="Análise do Mercado"
      class="ml-1"
      @click="abrirDialog()"
    >
      mdi-view-column
    </v-icon>

    <SysDialogFullScreen
      v-model="dialog"
      titulo="Análise de Mercado"
      class="pa-0"
      content-class="bra-20"
    >
      <Tabela :dados="dados" class="mx-1" />
    </SysDialogFullScreen>
  </div>
</template>

<script>
import SysDialogFullScreen from '../../../padraoDeLayout/SysDialogFullScreen.vue';
import { buscarCloseUpProduto } from '../../../../api/compras/CloseUp';
import Tabela from './Tabela.vue';
import { mapGetters } from 'vuex';

export default {
  components: { SysDialogFullScreen, Tabela },
  props: {
    produto: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      dados: []
    };
  },
  computed: {
    ...mapGetters({
      grupo: "usuario/getGrupoCompras",
      filial: "usuario/getFilialCompras",
    })
  },
  methods: {
    abrirDialog() {
      this.dialog = true;
      this.buscarCloseUp();
    },
    buscarCloseUp() {
      const parametros = {
        idgrupo: this.produto.id_grupo,
        idfilial: this.filial,
        idproduto: this.produto.idproduto
      }

      this.$store.dispatch(
        'loading/addRequisicao',
        buscarCloseUpProduto(parametros).then((d) => this.dados = d)
      );
    }
  }
}
</script>

<style>

</style>
